<template>
  <user-layout>

    <div class="max-w-4xl mx-auto">

      <div class="flex flex-wrap items-center">
        <div class="w-full md:w-1/6 lg:w-1/6">
          <div class="flex items-center justify-center w-24 h-24 bg-blue-500 rounded-full md:w-32 md:h-32">
            <div class="text-white text-5xl font-semibold">
              {{ userRating && userRating.receiverName && userRating.receiverName.split(' ').map((n) => n[0]).join('') }}
            </div>
          </div>
        </div>
        <div class="w-full md:w-5/6 lg:w-5/6 py-3">
          <div>
            <h3 class="font-bold text-2xl">{{ userRating.receiverName }}</h3>
            <p class="font-semibold">{{ userRating.receiverAreaName }}</p>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap items-center justify-between mb-3">

        <div class="w-full md:w-1/2 lg:w-1/2">
          <div v-for="cr in userRating.criterionRatings" class="py-3">
            <p class="font-semibold text-blue-400 uppercase">{{ cr.criterionName }}</p>
            <div class="flex flex-wrap justify-between py-1">
              <span>1</span><span>10</span>
            </div>
            <slider
                v-model="cr.rate"
                orientation="horizontal"
                :min="1"
                :max="10"
                :step="0.01">
            </slider>
          </div>
        </div>

        <div class="w-full md:w-1/2 lg:w-1/2">
          <div class="px-3">
            <h2 class="font-semibold text-blue-400 py-3 uppercase">
              Kommentaar <span class="font-semibold text-red-400">*</span>
            </h2>
            <textarea
                v-model="userRating.comment"
                placeholder=" ..."
                rows="20"
                cols="35"
                maxlength="500"
            />
          </div>
        </div>
      </div>

      <div class="right-0 text-right px-3">
        <button v-if="this.userRatingIndex !== this.projectRating.userRatings.length-1" class="pi pi-arrow-circle-right text-blue-400 text-4xl " @click="next" ref="nextButton"></button>
        <button v-else class="uppercase text-white bg-blue-500 btn w-full sm:w-auto md:px-24" @click="finish" ref="finishButton">Lõpeta</button>

        <div>{{ userRatingIndex + 1 }}/{{ projectRating.userRatings.length }}</div>
      </div>

    </div>

  </user-layout>
</template>

<script>
import UserLayout from './../Layouts/UserLayout'
import {getProjectRating, rate} from "@/store/rating.api";
import {pushToProject} from "@/routes";

export default {
  components: {
    UserLayout,
  },
  data() {
    return {
      projectRating: {
        projectId: '',
        giverProjectUserId: -1,
        userRatings: [
          {
            receiverProjectUserId: -1,
            receiverName: '',
            receiverAreaName: '',
            comment: '',
            criterionRatings: [
              {
                criterionId: -1,
                criterionName: '',
                rate: null
              }
            ]
          }
        ]
      },
      userRatingIndex: 0,
      userRating: {},
      criterionRate: {}
    };
  },
  methods: {

    loadProjectRatings() {
      getProjectRating(this.$route.params.giverProjectUserId)
      .then(projectRating => {
        this.projectRating = projectRating
        this.setUserRating();
      });
      //TODO (07.01.2023) Andrei Sljusar: {"toastType":"warn","toast":"Projekt: cfffa12b-456c-49e7-b8f4-c1b1ec36fd52 peab olema lõpetatud. Hetkel: ACTIVE.","projectUserId":null}
    },
    setUserRating() {
      if (this.projectRating.userRatings.length === 0) {
        pushToProject(this.$route.params.giverProjectUserId, this.$router);
        return;
      }
      this.criterionRate = {};
      this.userRating = this.projectRating.userRatings[this.userRatingIndex];
      this.userRating.criterionRatings.forEach(cr => {
        this.criterionRate[cr.criterionId] = cr.rate;
      });
    },
    finish() {
      this.$refs.finishButton.classList.add('p-disabled');
      this.rate().then(response => {
        this.$refs.finishButton.classList.remove('p-disabled');
        //TODO (07.01.2023) Andrei Sljusar: User is not a member of the project
        pushToProject(this.$route.params.giverProjectUserId, this.$router)
        setTimeout(() => {
          this.$toast.add({
            severity: 'success',
            summary: 'Kõik hinnangud on salvestatud',
            life: 3000,
            closable: false
          })
        }, 100);
      }, (error) => {
        this.$refs.finishButton.classList.remove('p-disabled');
        const toast = error.response?.data;
        if (toast) {
          this.processAxiosPositiveResponse(toast);
        }
      })
    },
    next() {
      this.$refs.nextButton.classList.add('p-disabled');
      this.rate().then(response => {
        this.$refs.nextButton.classList.remove('p-disabled');
        this.userRatingIndex = ++this.userRatingIndex % this.projectRating.userRatings.length;
        this.setUserRating();
        setTimeout(() => {
          this.$toast.add({
            severity: 'success',
            summary: 'Hinnang on salvestatud',
            life: 3000,
            closable: false
          })
        }, 100);
      }, (error) => {
        this.$refs.nextButton.classList.remove('p-disabled');
        const toast = error.response?.data;
        if (toast) {
          this.processAxiosPositiveResponse(toast);
        }
      })
    },
    rate() {
      return rate({
        giverProjectUserId: this.projectRating.giverProjectUserId,
        receiverProjectUserId: this.userRating.receiverProjectUserId,
        comment: this.userRating.comment,
        criterionRatings: this.userRating.criterionRatings
      });

    }
  }, mounted() {
    this.loadProjectRatings();
  }
}
</script>
<style>
.p-slider {
  background: #C2C2C2 !important;
}

textarea {
  font-size: 20px;
  width: 100%;
}
</style>
